import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
}
export function Card({
  children,
  className = '',
  title,
  description,
  action
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`} data-id="element-253">
      {(title || action) && <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center" data-id="element-254">
          <div data-id="element-255">
            {title && <h3 className="text-lg font-medium text-gray-900" data-id="element-256">{title}</h3>}
            {description && <p className="mt-1 text-sm text-gray-500" data-id="element-257">{description}</p>}
          </div>
          {action && <div data-id="element-258">{action}</div>}
        </div>}
      <div className="p-6" data-id="element-259">{children}</div>
    </div>;
}